import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '../../stores/authStore';

type AdminGuardProps = {
  children: React.ReactNode;
};

/**
 * Wraps admin-only routes. Redirects to /login if not authenticated,
 * or to / if authenticated but not admin.
 */
export function AdminGuard({ children }: AdminGuardProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const role = useAuthStore((s) => s.user?.role);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
